import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import TagManager from 'react-gtm-module';
import ReactGA from 'react-ga';
// import NewRelic from 'new-relic-agent-react';
import runtime from 'serviceworker-webpack-plugin/lib/runtime';
import registerEvents from 'serviceworker-webpack-plugin/lib/browser/registerEvents';

import './assets/css/style.css';
import 'react-modern-calendar-datepicker/lib/DatePicker.css';
import { Router } from './Router';
// import { register as registerServiceWorker } from './serviceWorker';
import configureStore from './utils/configureStore';
import ReactQuery from './ReactQuery';
/**
 * Google Tag Manager
 */

const tagManagerArgs = {
  gtmId: process.env.GTM_ID || '',
};

TagManager.initialize(tagManagerArgs);

ReactGA.initialize(process.env.GOOGLE_ANALYTICS_TOKEN || '');

const store = configureStore();

if (
  'serviceWorker' in navigator &&
  (window.location.protocol === 'https:' || window.location.hostname === 'localhost')
) {
  const registration = runtime.register();

  registerEvents(registration, {});
} else {
  console.log('serviceWorker not available');
}

ReactDOM.render(
  <Provider store={store}>
    <ReactQuery>
      {/* <NewRelic
        licenseKey="8ca282eb0d25c31f31b724ae61904bcbFFFFNRAL"
        applicationID="2960009"
      /> */}
      <Router />
    </ReactQuery>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// registerServiceWorker();
